import { ToggleOpenData } from '~globals/types/commons';

import { useToggle } from './useToggle';

export interface UseImportsOrdersDialogsStateParams {
  defaultOpenDialogImportFromFile?: boolean;
  defaultOpenDialogImportFromIntegration?: boolean;
  defaultOpenImportFromAssociatedCompany?: boolean;
}

export interface UseImportsOrdersDialogsStateDialogsReturn {
  importFromFile: ToggleOpenData;
  importFromIntegration: ToggleOpenData;
  importFromAssociatedCompany: ToggleOpenData;
}

export const useImportsOrdersDialogsState = (
  params?: UseImportsOrdersDialogsStateParams,
): UseImportsOrdersDialogsStateDialogsReturn => {
  const [openDialogImportFromFile, toggleOpenDialogImportFromFile] = useToggle(
    params?.defaultOpenDialogImportFromFile ?? false,
  );

  const [
    openDialogImportFromIntegration,
    toggleOpenDialogImportFromIntegration,
  ] = useToggle(params?.defaultOpenDialogImportFromIntegration ?? false);

  const [
    openDialogImportFromAssociatedCompany,
    toggleOpenDialogImportFromAssociatedCompany,
  ] = useToggle(params?.defaultOpenImportFromAssociatedCompany ?? false);

  return {
    importFromFile: {
      open: openDialogImportFromFile,
      toggleOpen: toggleOpenDialogImportFromFile,
    },
    importFromIntegration: {
      open: openDialogImportFromIntegration,
      toggleOpen: toggleOpenDialogImportFromIntegration,
    },
    importFromAssociatedCompany: {
      open: openDialogImportFromAssociatedCompany,
      toggleOpen: toggleOpenDialogImportFromAssociatedCompany,
    },
  };
};
